module.exports = __webpack_public_path__ + "img/to do-no-text.1e55c651.svg";